<template>
  <div class="container">
    <el-row style="background-color: #ffffff">
      <content-title :nav="nav"></content-title>
    </el-row>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        :label="pane.label"
        :name="pane.ref"
        v-for="(pane, i) in paneList"
        :key="i"
      >
        <categoryList :ref="pane.ref" :source="pane.source"></categoryList>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
  
  <script>
import categoryList from "./components/categoryList.vue";

export default {
  components: {
    categoryList,
  },
  data() {
    return {
      nav: { firstNav: "类目管理中心", secondNav: "类目管理" },
      activeName: 'sport',
      paneList: [
        {
          label: "体育课程",
          source: "课程",
          ref: "sport",
        },
         {
          label: "休闲生活",
          source: "休闲生活",
          ref: "life",
        },
         {
          label: "夜校",
          source: "夜校",
          ref: "night",
        },
           
         {
          label: "共享空间",
          source: "space",
          ref: "space",
        },
        {
          label: "空间热门",
          source: "space_hot",
          ref: "space_hot",
        },
         {
          label: "商城",
          source: "商城",
          ref: "shop",
        },
        {
          label: "培训",
          source: "培训",
          ref: "promote",
        },
         {
          label: "考证",
          source: "考证",
          ref: "cert",
        },
         {
          label: "开店办证",
          source: "办证",
          ref: "storeCert",
        },
           {
          label: "设备",
          source: "设备",
          ref: "device",
        },
        
        {
          label: "陪练",
          source: "陪练",
          ref: "partner",
        },
         {
          label: "棋牌",
          source: "棋牌",
          ref: "chess",
        },
         {
          label: "商务合作",
          source: "商务合作",
          ref: "business",
        },
         {
          label: "儿童陪伴",
          source: "儿童陪伴",
          ref: "child",
        },
        {
          label: "陪诊陪护",
          source: "陪诊陪护",
          ref: "old",
        },
        {
          label: "小店",
          source: "mec_shop",
          ref: "mec_shop",
        },
         {
          label: "德商汇商城",
          source: "dsh_shop",
          ref: "dsh_shop",
        },
      ],
    };
  },
  mounted() {
      this.$nextTick(()=>{
        this.$refs[this.activeName][0].load();
      })
  },
  methods: {
    handleClick(v) {
      this.$refs[v.name][0].load();
    },
  },
};
</script>
  
  <style lang="less">
</style>
  